import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

/**
 * TREASURE VAULT (Сокровищница) — the glittering hidden hoard, the discovery room (sealed). A tall, narrow
 * shrine to plunder: a beam of warm light falls on the HERO relic pedestal at the north end (the payoff),
 * and the eye is drawn down a jewel-toned aisle — open gold chests + the assayer's scales, crown-jewel
 * plinths, then two DRAGON guardians flanking a single viewing bench so a duck can sit and gawk at the
 * relic. Restrained, gold-glint, jewel-toned — never gaudy. A gilded bonsai keeps the cold stone warm.
 *
 * Geometry: zone (1340,40) 220×580 → interior x1352..1548, y52..608, centre (1450,330). The relic
 * pedestal (HERO interactive) is rendered separately at (1450,150) — we compose AROUND it. Door on the
 * WEST wall at y510 (gap y450..570) is kept clear.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;

  // ── Two glinting gold chests flank the HERO relic at the north end (interactive pedestal at 1450,150). ──
  place(ctx, kit.treasurePile(art), 1394, 108);
  place(ctx, kit.treasurePile(art), 1506, 108);

  // ── The assayer's bench: an open gold chest + a gem plinth flanking the gold scales, below the relic. ──
  place(ctx, kit.treasurePile(art), 1396, 250);
  place(ctx, kit.gemPlinth(art), 1504, 250);
  place(ctx, kit.goldScales(art), 1450, 248);

  // ── The crown jewels on their plinths, a matched pair down the aisle. ──
  place(ctx, kit.gemPlinth(art), 1396, 360);
  place(ctx, kit.gemPlinth(art), 1504, 360);

  // ── Two DRAGON statue guardians flanking the viewing bench — the last thing between a duck and the hoard. ──
  place(ctx, kit.dragonStatue(art), 1392, 440);
  place(ctx, kit.dragonStatue(art), 1508, 440);

  // ── The viewing bench (seat anchor) — sit and gaze north at the glowing relic. ──
  place(ctx, kit.pew(art, 80), 1450, 470);

  // ── The south end stays a working vault: more hoard + a sealed reserve cask + warm gold light. ──
  place(ctx, kit.treasurePile(art), 1398, 556);
  place(ctx, kit.cask(art), 1508, 552);
  place(ctx, kit.candelabra(art), 1450, 520);
  place(ctx, kit.wallTorch(art), 1370, 200);
  place(ctx, kit.wallTorch(art), 1530, 200);
};

export default decorate;
